<div class="signalStrengthBars">
    <span class="signalBar bar1" [ngClass]="highlightBar(0)"></span>
    <span class="signalBar bar2" [ngClass]="highlightBar(1)"></span>
    <span class="signalBar bar3" [ngClass]="highlightBar(2)"></span>
    <span class="signalBar bar4" [ngClass]="highlightBar(3)"></span>
    <span class="signalBar bar5" [ngClass]="highlightBar(4)"></span>
</div>
